
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Dhamal Dandiya </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm dhamaal-dandiya-year2016 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Dhamal<span > Dandiya   Event 2016</span></h2>
        </div>
        <div class="row text-justify">
            <div class="col-md-12">

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 1</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/Bbt2pErza5Bqs5G98" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/1.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/2.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/3.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/4.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 2</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/KuY5Q381784V4nXF8" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/5.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/8.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 3</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/94BuB2gU6AqtThvc6" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/6.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/10.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/10.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/10.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/11.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/11.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/11.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/12.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/12.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/12.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>DHAMAL DANDIYA DAY 4</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/HrdPvzSuNGMJ9Tmv6" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/13.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/13.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/13.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/14.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/14.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/14.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/15.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/15.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/15.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 5 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/jeMi1bW8afrZsDJj7" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/18.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/18.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/18.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/16.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/20.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/20.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/20.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 6 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/cXz6td2xLPaRg17HA" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/21.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/21.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/21.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/22.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/22.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/22.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/23.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/23.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/23.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/24.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/24.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/24.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 7 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/w7yVxhwjizn5jJpz8" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/25.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/25.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/25.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/28.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/28.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/28.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 8</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/mroo161poyoSrMjV8" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/26.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/30.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/30.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/30.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/31.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/31.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/31.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/32.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/32.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/32.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 9 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/VHLxh3Rm3bQku2tx8" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/33.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/33.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/33.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/34.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/34.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/34.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/35.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/35.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/35.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/36.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/36.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/36.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>



                    </ul>
                </div>

                <div class="border-line-sm"></div>

                <div class="row mt-3">
                    <div class="col-md-8">
                        <div class="widget_title inner-title shadow-text-sm">
                            <h4>Dhamal Dandiya Day 10 </h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">

                        <a href="https://goo.gl/photos/pLBbMvFxWu5tJe6f7" target="_blank"
                            class="btn button--effect-1"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">

                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/37.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/37.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/37.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/38.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/38.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/38.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/39.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/39.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/39.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/40.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/40.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/gallery/dd2016/40.webp"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>
        </div>


    </div>
</section>
